import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';

import { useIsBusy } from '../../../data/hooks/ui/useIsBusy';
import styles from './Toast.module.scss';

const Toast = (props) => {
    const queue = useSelector((state) => state.ui.toasts),
        isBusy = useIsBusy(),
        [message, setMessage] = useState(),
        [isVisible, setVisible] = useState(false);

    // Pick next message to show
    useEffect(() => {
        if (queue.length && !message) {
            let nextMessage = [...queue].shift();
            setMessage(nextMessage);
            setVisible(true);
        }
    }, [queue]);

    // Timeout to clear message
    useEffect(() => {
        if (!isBusy && message) {
            if (isVisible) {
                let timeoutID = setTimeout(() => setVisible(false), 2500);
                return () => clearTimeout(timeoutID);
            } else {
                let timeoutID = setTimeout(() => {
                    setMessage(null);
                    app.store.dispatch(app.actions.ui.toast.done(message));
                }, 1000);
                return () => clearTimeout(timeoutID);
            }
        }
    }, [isBusy, message, isVisible]);

    // OUTPUT
    if (!message) return null;

    return (
        <div
            className={[
                styles.Toast,
                isVisible ? styles.visible : styles.hidden,
            ].join(' ')}
        >
            {message}
        </div>
    );
};

export default Toast;
